import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDialogModule } from "@angular/material/dialog";
import { MatListModule } from "@angular/material/list";

import { TranslateModule } from "@ngx-translate/core";
import { CKEditorModule } from "ckeditor4-angular";

import { FuseSharedModule } from "@fuse/shared.module";
import {
    SpecificationRepairReviewComponent,
    DialogContentExampleDialog,
} from "./specification-repair-review.component";

const routes = [
    {
        path: "specification-repair-review/:propertyId",
        component: SpecificationRepairReviewComponent,
    },
];

@NgModule({
    // entryComponents:[DialogContentExampleDialog],
    declarations: [
        SpecificationRepairReviewComponent,
        DialogContentExampleDialog,
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDatepickerModule,
        MatListModule,
        MatTabsModule,
        MatDialogModule,
        FuseSharedModule,
        CKEditorModule,
    ],
    exports: [SpecificationRepairReviewComponent, DialogContentExampleDialog],
})
export class SpecificationRepairReviewModule {}
